import React, {useMemo} from 'react';
import useAuth from '../../../utils/AuthContext';
import CustomerError from '../../../components/CustomerError';
import UseUser, {IUser, UserGrade, UserType} from '../../../hooks/apis/useUser';
import {Button, Card, Checkbox, Radio, Space, Table} from 'antd';
import Search from 'antd/lib/input/Search';
import {useBoolean, useInput} from 'react-hanger';
import ImportUserExcel from '../../../components/user/ImportUserExcel';
import CommonApiErrorHandler from '../../../utils/HttpInstance';
import {useMount} from 'react-use';

export default function ManagerUserList() {
  const auth = useAuth();
  const listState = UseUser.list();
  const keyword = useInput('');
  const isReviewer = useBoolean(false);
  function refresh() {
    listState
      .request()
      .then()
      .catch(CommonApiErrorHandler);
  }

  useMount(() => {
    refresh();
  });

  const displayList = useMemo(() => {
    return (
      listState.data
        ?.filter(i => {
          if (i.type === UserType.管理员) return false;
          if (isReviewer.value) return i.type === UserType.评审员;
          return i.type === UserType.普通账号;
        })
        .filter(i => {
          return (i.legalName + i.schoolName + i.coachName + i.telephone + i.userName).includes(keyword.value);
        }) ?? []
    );
  }, [listState.data, keyword.value, isReviewer.value]);

  if (!auth.currentUser || auth.currentUser.type !== UserType.管理员) return <CustomerError title={'无操作权限'} />;
  return (
    <div>
      <Card
        title={'用户列表'}
        extra={
          <Space>
            <ImportUserExcel refresh={refresh} isReviewer={isReviewer.value} />
            <Button onClick={refresh}>刷新</Button>
          </Space>
        }>
        <Space style={{marginBottom: 15}}>
          <Search {...keyword.eventBind} width={300} />
          <Radio.Group value={isReviewer.value} onChange={e => isReviewer.setValue(e.target.value)}>
            <Radio value={false}>学生</Radio>
            <Radio value={true}>评审员</Radio>
          </Radio.Group>
        </Space>
        <Table<IUser> loading={listState.loading} rowKey={'id'} dataSource={displayList} bordered size={'small'}>
          <Table.Column<IUser> title={'ID'} dataIndex={'id'} />
          <Table.Column<IUser> title={'用户名'} dataIndex={'userName'} />
          <Table.Column<IUser> title={'姓名'} dataIndex={'legalName'} />
          {!isReviewer.value && (
            <React.Fragment>
              <Table.Column<IUser> title={'学校'} dataIndex={'schoolName'} />
              <Table.Column<IUser> title={'班级'} render={(_, item) => UserGrade[item.grade] + ' ' + item.classNo + ' 班'} />
              <Table.Column<IUser> title={'联系方式'} dataIndex={'telephone'} />
              <Table.Column<IUser> title={'指导老师'} dataIndex={'coachName'} />
            </React.Fragment>
          )}
        </Table>
      </Card>
    </div>
  );
}
